<ng-container *ngIf="isReadonly; then readonlyContent; else editableContent"></ng-container>

<ng-template #readonlyContent>
  <div [class]="cssClass" container="body" placement="bottom" [formGroup]="form">
    <div class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label>{{ '(' + ('::AttachedData' | abpLocalization) + ')' }}</label>
      </div>
      <div
        class="col-auto"
        *blockUI="blockUiNameAttachedDataReadonly; template: blockTemplateReadonly">
        <label>{{ currentAttachedDataName }}</label>
      </div>
      <div class="col-auto">
        <label>{{ payload.operator | operator }}</label>
      </div>
      <div class="col-auto">
        <span *ngIf="loading">{{ 'CA::Loading' | abpLocalization }}...</span>
        <span *ngIf="!loading">
          <ng-container *ngIf="isSelectedAttachedDataMultipleChoice; else singleChoice">
            <ng-container *ngIf="selectedDatas.length === 1; else multipleItems">
              {{ selectedDatas[0].value }}
            </ng-container>
          </ng-container>
        </span>

        <ng-template #multipleItems>
          <span [attr.title]="attachedDataNameList">
            {{ '::XItemsSelected' | abpLocalization : selectedDatas.length }}
          </span>
        </ng-template>

        <ng-template #singleChoice>
          {{ payload.value }}
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editableContent>
  <div [class]="cssClass" container="body" placement="bottom" [formGroup]="form">
    <div showButtonsOnHover class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label>{{ 'Conversation::QueryBuilder:AttachedData' | abpLocalization }}</label>
      </div>
      <div class="col-auto" *blockUI="blockUiNameAttachedData; template: blockTemplate">
        <ca-select
          class="attached-data-category"
          formControlName="attachedDataId"
          (change)="attachedDataSelectionChanged($event)"
          [optionStyle]="'max-width: 300px !important'"
          [(ngModel)]="payload.attachedDataId">
          <ca-option *ngFor="let attachedData of attachedDataList" [value]="attachedData.id">
            {{ attachedData.name }}
          </ca-option>
        </ca-select>
      </div>
      <div class="col-auto">
        <select
          class="form-select form-select-sm"
          [(ngModel)]="payload.operator"
          formControlName="operator">
          <option *ngFor="let operator of node.categoryItem.operators" [value]="operator">
            {{ operator | operator }}
          </option>
        </select>
      </div>
      <div class="col-auto" *blockUI="blockUiNameAttachedDataLookups; template: blockTemplate">
        <input
          *ngIf="!isSelectedAttachedDataMultipleChoice"
          type="text"
          [(ngModel)]="payload.value"
          class="form-control form-control-sm attached-data-category"
          formControlName="attachedDataValue"
          placeholder="{{ 'Query::QueryTermWatermark' | abpLocalization }}" />
        <ca-select
          *ngIf="isSelectedAttachedDataMultipleChoice"
          class="attached-data-category"
          formControlName="attachedDataValue"
          [multiple]="true"
          (change)="attachedDataValueSelectionChanged($event)"
          [optionStyle]="'max-width: 300px !important'">
          <ca-option
            *ngFor="let attachedDataLookup of selectedAttachedDataLookupList"
            [value]="attachedDataLookup.id">
            {{ attachedDataLookup.value }}
          </ca-option>
        </ca-select>
      </div>
      <div style="gap: 8px" class="col-auto d-flex flex-row justify-content-center">
        <ca-query-builder-node-duplicate-button
          (buttonClick)="onClickDuplicate($event)"></ca-query-builder-node-duplicate-button>
        <ca-query-builder-node-remove-button
          (buttonClick)="removeNode($event)"></ca-query-builder-node-remove-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #blockTemplate>
  <div class="d-flex justify-content-center align-items-center block-ui-template">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="sr-only">...</span>
    </div>
  </div>
</ng-template>

<ng-template #blockTemplateReadonly>
  <div class="d-flex justify-content-center align-items-center block-ui-template">
    <div class="spinner-border" style="width: 10px; height: 10px" role="status">
      <span class="sr-only">...</span>
    </div>
  </div>
</ng-template>
